import jwtDecode from 'jwt-decode/lib/index';
import humps from 'humps';

import * as ACTION_TYPES from './types';

const generateUserState = ({ accessToken = '', ...rest }) => {
  let tokenInfo = {};
  if (accessToken.length) {
    tokenInfo = humps.camelizeKeys(jwtDecode(accessToken));
  }
  return {
    token: accessToken,
    ...rest,
    ...tokenInfo,
  };
};

const initialState = {
  data: generateUserState({}),
  challengerId: '',
  details: {},
  magicToken: null,
};

const authReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.IAM_DOCTOR_LOGIN_SUCCESS:
      return {
        ...state,
        data: payload,
        challengerId: payload.data.challengerId,
      };

    case ACTION_TYPES.AUTH_OTP_RESEND_REQUEST_SUCCESS:
      return {
        ...state,
        challengerId: payload.data.challengerId,
      };

    case ACTION_TYPES.IAM_VERIFY_OTP_SUCCESS:
      if (payload.data?.status === 4) {
        return {
          ...state,
          magicToken: payload.data.magicToken,
        };
      }
      return {
        ...state,
        data: generateUserState({ ...payload.data.token, isAuthenticated: true }),
      };
    case ACTION_TYPES.IAM_LIMITED_DEVICE_LOGIN_SUCCESS:
      return {
        ...state,
        data: generateUserState({ ...payload.data.token, isAuthenticated: true }),
      };

    case ACTION_TYPES.UPDATE_ACCESS_TOKEN_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          token: payload.data?.token?.access_token,
        },
      };
    case ACTION_TYPES.AUTH_LOGOUT:
    case ACTION_TYPES.UPDATE_ACCESS_TOKEN_FAILED:
      return initialState;

    case ACTION_TYPES.IAM_USER_DETAILS_SUCCESS:
      return {
        ...state,
        details: payload,
      };

    default:
      return state;
  }
};

export default authReducer;
